export default {
  1: ['yellow', '#FFE9AD'], // Tender
  5: ['orange','#FF8C00'], // Pre Start
  2: ['green','#006400'], // On Site
  3: ['red','#B22222'], // Complete
  4: ['blue','#4682B4'] // Awaiting Next Phase
}
